import React, { useEffect, useState } from "react";
import { Input } from "@components/atoms/input/input";
import styles from "./input-and-chars-counter.module.scss";
import { useI18N } from "@src/language/language-context";

interface InputAndCharsCounterTypes {
  initialValue: string;
  callback: (value: string) => void;
}

const cssClassName = "input-and-chars-counter";

export const InputAndCharsCounter = ({
  initialValue,
  callback,
}: InputAndCharsCounterTypes) => {
  const i18n = useI18N();
  const [inputValue, setInputValue] = useState(initialValue);
  const [charsCount, setCharsCount] = useState(0);

  const texts = {
    inputLabel: i18n("modules.saveBlueprintModal.inputLabel"),
    inputPlaceHolder: i18n("modules.saveBlueprintModal.inputPlaceHolder"),
  };

  const maxCountInputLimit = 50;

  const setInputValueAndCharsCount = (
    inputValue,
    limit = maxCountInputLimit,
  ) => {
    const value = inputValue.substring(0, limit);
    setInputValue(value);
    setCharsCount(value.length);
  };

  const inputOnChange = (e) => {
    setInputValueAndCharsCount(e.target.value);
    callback(e.target.value);
  };

  useEffect(() => {
    setInputValueAndCharsCount(initialValue);
  }, [initialValue]);

  return (
    <div className={styles[`${cssClassName}__input-wrapper`]}>
      <Input
        inputVariant={"dark-background"}
        labelText={texts.inputLabel}
        inputPlaceHolder={texts.inputPlaceHolder}
        inputValue={inputValue}
        onChangeFunc={inputOnChange}
        maxLength={maxCountInputLimit}
      />
      <p className={styles[`${cssClassName}__chars-counter`]}>
        {charsCount}/{maxCountInputLimit}
      </p>
    </div>
  );
};
